import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/**
 * Breadcrumbs - slash-separated trail e.g.:
 *   Home › Solutions › iExchangeWeb
 *
 * Pass an array of `{ label, to? }` items. The last item is treated as the
 * current page (no link). Pass `home: false` to suppress the leading Home link.
 */
const Breadcrumbs = ({ items = [], home = true, className = '' }) => {
  const trail = home
    ? [{ label: 'Home', to: '/', icon: Home }, ...items]
    : items;

  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center flex-wrap gap-1 text-sm text-text-muted font-mono ${className}`}
    >
      {trail.map((item, idx) => {
        const isLast = idx === trail.length - 1;
        const Icon = item.icon;
        return (
          <React.Fragment key={`${item.label}-${idx}`}>
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="inline-flex items-center gap-1 hover:text-accent-primary transition-colors"
              >
                {Icon && <Icon size={13} className="opacity-70" />}
                <span>{item.label}</span>
              </Link>
            ) : (
              <span
                aria-current={isLast ? 'page' : undefined}
                className={`inline-flex items-center gap-1 ${
                  isLast ? 'text-text-secondary font-semibold' : ''
                }`}
              >
                {Icon && <Icon size={13} className="opacity-70" />}
                <span>{item.label}</span>
              </span>
            )}
            {!isLast && (
              <ChevronRight
                size={14}
                className="text-border-subtle mx-1"
                aria-hidden
              />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
